/**
 * Configuration data for the LoginTracking view
 * Contains color schemes and UI configurations
 */

// Color schemes for stat cards
export const STAT_CARD_COLORS = {
  totalLogins: {
    bg: "#E3F2FD",
    icon: "#1976D2",
  },
  successfulLogins: {
    bg: "#E8F5E9",
    icon: "#4CAF50",
  },
  failedLogins: {
    bg: "#FFEBEE",
    icon: "#F44336",
  },
  last7Days: {
    bg: "#FFF3E0",
    icon: "#FF9800",
  },
  last3Days: {
    bg: "#F3E5F5",
    icon: "#9C27B0",
  },
};

// Status colors used across the view
export const STATUS_COLORS = {
  success: "#4CAF50",
  failure: "#F44336",
  primary: "#0a2240",
  secondary: "#1976D2",
  warning: "#FFC107",
  neutral: "#666",
};

// Table configuration
export const TABLE_CONFIG = {
  dailyLoginsLimit: 10,
  topUsersLimit: 10,
  recentEventsLimit: 20,
  maxTableHeight: 500,
};

// Chip styles for different contexts
export const CHIP_STYLES = {
  dailyCount: {
    backgroundColor: "#E3F2FD",
    color: "#1976D2",
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  topPosition: (index) => ({
    backgroundColor: index < 3 ? "#FFC107" : "#E0E0E0",
    color: index < 3 ? "#000" : "#666",
    fontWeight: 600,
  }),
  failureError: {
    backgroundColor: "#FFCDD2",
    color: "#C62828",
    fontSize: "0.75rem",
  },
  successClient: {
    backgroundColor: "#C8E6C9",
    color: "#2E7D32",
    fontSize: "0.75rem",
  },
};

// Table header style
export const TABLE_HEADER_STYLE = {
  fontWeight: 600,
  backgroundColor: "#f8f9fa",
  fontFamily: "Montserrat",
};

/**
 * Format date for display in daily logins table
 * @param {string} dateStr - Date string to format
 * @returns {string} Formatted date string
 */
export const formatLoginDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

/**
 * Format datetime for display in event tables
 * @param {string} dateTimeStr - DateTime string to format
 * @returns {string} Formatted datetime string
 */
export const formatEventDateTime = (dateTimeStr) => {
  return new Date(dateTimeStr).toLocaleString("en-US");
};

/**
 * Calculate percentage of user logins
 * @param {number} userCount - User's login count
 * @param {number} totalCount - Total login count
 * @returns {string} Percentage string with 1 decimal place
 */
export const calculateLoginPercentage = (userCount, totalCount) => {
  return ((userCount / (totalCount || 1)) * 100).toFixed(1);
};
